import './CalendarDate.css';
export default {
    "calendarCell": "CalendarDate_calendarCell__15l2m",
    "selected": "CalendarDate_selected__15l2m",
    "enabled": "CalendarDate_enabled__15l2m",
    "today": "CalendarDate_today__15l2m",
    "icon": "CalendarDate_icon__15l2m",
    "selectedIcon": "CalendarDate_selectedIcon__15l2m"
};
